import { UPDATE_CIRCULAR_ROUTE } from "Announcements/modules/constants";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: `circulars/:circular_id/${UPDATE_CIRCULAR_ROUTE}`,
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-communications" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
